import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getTimesheetEntriesQueryKey } from '../timesheet-entry/query-key';
import { invalidateTimesheetRowsQuery } from '../timesheet-row/query';
import { invalidateTimesheetQuery, setTimesheetQueryData } from './query';
export function usePostTimesheetSubmitSettled() {
    const queryClient = useQueryClient();
    return useCallback(async (timesheetId) => {
        setTimesheetQueryData(queryClient, timesheetId, (draft) => {
            draft.submitState = 'NOT_SUBMITTING';
            return draft;
        });
        await Promise.all([
            invalidateTimesheetQuery(queryClient, timesheetId),
            invalidateTimesheetRowsQuery(queryClient, timesheetId),
            queryClient.invalidateQueries({
                queryKey: getTimesheetEntriesQueryKey(timesheetId),
            }),
        ]);
    }, [queryClient]);
}
//# sourceMappingURL=use-post-timesheet-submit-settled.js.map